import { ContestCategoryModule } from '@/modules/fantasy/fixture/contest-category';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/dashboard/fantasy/fixture/contest-category'
)({
  component: ContestCategoryPage,
});

function ContestCategoryPage() {
  return <ContestCategoryModule />;
}
